module.exports = __webpack_public_path__ + "img/AMGN.0b376784.png";